module.exports = __webpack_public_path__ + "static/media/seletar-back.e49267ae.png";